import {
  getCheckoutFormValues,
  setSectionLabel,
} from 'app/services/businessFunctionHelpers';
import { FormsEnum, LabelEnum, SectionsEnum } from 'app/shared/enums';

const firstCoownerNameAndLastNameChange = {
  updateCoowner1Label() {
    const name = getCheckoutFormValues().coowners[1].nameCheckoutForm || '';
    const lastName =
      getCheckoutFormValues().coowners[1].lastNameCheckoutForm || '';
    setSectionLabel({
      key: SectionsEnum.CheckoutSectionInsurant4Owner,
      formName: FormsEnum.CheckoutForm,
      label: `${LabelEnum.CoOwner} - ${name} ${lastName}`,
    });
  },
};

export default firstCoownerNameAndLastNameChange;
